import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "note-time"
};
var _hoisted_2 = {
  class: "note-time lick-box"
};
import { ref, reactive, onMounted, toRefs, onUnmounted, watch } from 'vue';
import empty from '../widgets/empty';
import { MessagePlugin } from 'tdesign-vue-next';
import { getNote, giveALike } from '@/api/spaceInfo.js';
import bus from '@/util/bus.js';
export default {
  __name: 'index',
  props: {
    visitorType: {
      // 个人视角(我自己)0，游客视角1(自己访问自己空间仍为个人视角)
      type: Number,
      default: 0
    },
    isOpenView: {
      // 个人视角(公开)
      type: Boolean,
      default: false
    },
    curUserId: {
      type: String
    },
    useToHome: {
      // 用于首页
      type: Boolean,
      default: false
    },
    showScope: {
      type: String
      // default: '0'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _toRefs = toRefs(props),
      useToHome = _toRefs.useToHome,
      showScope = _toRefs.showScope;
    var list = ref([]);
    var page = reactive({
      //分页
      size: 6,
      current: 1
    });
    var totalCount = ref(0);
    var isFinish = ref(false); //是否加载完毕
    var loading = ref('');
    var loadData = function loadData() {
      page.size = useToHome.value ? 3 : 6; // 该组件用于首页，差异处理
      getNote(props.curUserId, showScope.value, page).then(function (res) {
        var _list$value;
        var _res$data$data = res.data.data,
          records = _res$data$data.records,
          total = _res$data$data.total;
        // console.log(records, total, res.data.data, '-----res.data')
        totalCount.value = total;
        (_list$value = list.value).push.apply(_list$value, _toConsumableArray(records ? records : []));
        isFinish.value = page.current * page.size >= total;
        loading.value = '';
      });
    };
    var onLoad = function onLoad(val) {
      // console.log(isFinish.value, '-----isFinish', loading.value, '-----loading')
      if (isFinish.value || loading.value) {
        return;
      }
      if (val) page.current++;
      loading.value = 'loading';
      loadData();
    };
    var onScroll = function onScroll(scrollBottom) {
      console.log(scrollBottom, '---scrollBottom');
    };
    var handleLike = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item) {
        var opType, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              opType = Number(item.isLike) ? '0' : '1';
              _context.n = 1;
              return giveALike(item.id, '3', opType);
            case 1:
              item.isLike ? item.isLike = 0 : item.isLike = 1;
              item.isLike ? item.likeCount -= 1 : item.likeCount += 1;
              MessagePlugin.success('操作成功');
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              MessagePlugin.error('操作失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function handleLike(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    watch(function () {
      return showScope.value;
    }, function (val) {
      if (val) {
        // console.log(val, '----valnote', showScope.value, '---note showSCOP')
        list.value = [];
        isFinish.value = false;
        page.current = 1;
        onLoad();
      }
    }, {
      immediate: true
    });
    onMounted(function () {
      bus.on('scrollLoad', function (val) {
        // console.log(val, '---scrollLoad')
        if (useToHome.value) return; // 该组件用于首页，差异处理
        if (val) {
          onLoad(val);
        }
      });
    });
    onUnmounted(function () {
      bus.off('scrollLoad');
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_hxhy_note_item = _resolveComponent("hxhy-note-item");
      var _component_t_list = _resolveComponent("t-list");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["note", {
          empty: !list.value.length && !Boolean(loading.value) && !_unref(useToHome)
        }])
      }, [_createVNode(_component_t_list, {
        "async-loading": loading.value,
        onScroll: onScroll
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item) {
            return _openBlock(), _createBlock(_component_hxhy_note_item, {
              key: item.id,
              data: item,
              class: "note-item"
            }, {
              top_left: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_1, _toDisplayString(item.date) + " " + _toDisplayString(item.source ? '来自' + item.source : ''), 1)];
              }),
              top_right: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_svg_icon, {
                  name: item.isLike ? 'icon-black-lick' : 'icon-red-star',
                  class: "icon",
                  size: 14,
                  onClick: function onClick($event) {
                    return handleLike(item);
                  }
                }, null, 8, ["name", "onClick"]), _createElementVNode("span", null, _toDisplayString(item.likeCount), 1)])];
              }),
              _: 2
            }, 1032, ["data"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["async-loading"]), !list.value.length && !Boolean(loading.value) ? (_openBlock(), _createBlock(_unref(empty), {
        key: 0,
        type: 3,
        visitorType: __props.visitorType,
        "is-open-view": __props.isOpenView
      }, null, 8, ["visitorType", "is-open-view"])) : _createCommentVNode("", true)], 2);
    };
  }
};